module.exports = __webpack_public_path__ + "img/fond_vocabulary_list.562c3a69.jpg";